import { createIcon } from '@chakra-ui/react';

export const EnabledDot = createIcon({
  displayName: 'EnabledDot',
  viewBox: '0 0 13 13',
  path: [
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.2" cx="6.5" cy="6.5" r="6.5" fill="#00AF4F" />
      <circle cx="6.5" cy="6.5" r="4.0625" fill="#00AF4F" fillOpacity="0.7" />
    </svg>,
  ],
});
